import { useIntl } from 'react-intl'
import { Dropdown } from 'rsuite'
import { useDataTableStore } from '../../stores/DataTableStore'
import { useSettingsStore } from '../../stores/SettingsStore'
import { exportExcelPipeline } from '../../functions/ExportExcel/index'
import useNameColumnExcel from '../../hooks/NameColumnExcel'
import { useCustomeStore } from '../../stores/CustomeStore'
import { usePipelineStore } from '../../stores/PipelineStore'
import useUser from '../../hooks/User'
import { useParams } from 'react-router-dom'
import { TableColumn } from 'react-data-table-component'
import { Pipeline } from '../../interfaces/Pipeline'
import { useEffect, useState } from 'react'
import { currencyFormatter, getDateRangeDuration, getDateSummary } from '../../functions/general'
import { LogExportExcel } from '../../interfaces/Log'
import { TerminExportExcel } from '../../interfaces/Termin/Termin'
import { exportExcelLog } from '../../functions/ExportExcel/pipelines/log'
import { calculateDayDurations } from '../../functions/calculateDuration'
import { checkIsCompanyHarriette, checkIsCompanyTanrise, checkIsNewProgress } from '../../functions/customCase'
import { GET_CUSTOM_FIELD_COMPANY_HARRIETE } from '../../constant/General'
import { exportExcelTermin } from '../../functions/ExportExcel/pipelines/termin'
import moment from 'moment-timezone'

interface BtnActionDropdownExportExcelPipelineProps {
    columns: TableColumn<Pipeline>[]
    dateRange: [Date, Date]
}

const BtnActionDropdownExportExcelPipeline = ({ columns, dateRange }: BtnActionDropdownExportExcelPipelineProps) => {
    const intl = useIntl()
    const { isFullyLoaded, filteredTablesData } = useDataTableStore()
    const { settings } = useSettingsStore()
    const nameHeader = useNameColumnExcel();
    const { companyId, keyCustomfield } = useCustomeStore()
    const { selectMultiPipeline } = usePipelineStore()
    const user = useUser()
    const { templatePipelineId } = useParams()
    const [resultDataLog, setResultDataLog] = useState<LogExportExcel[]>([])
    const [resultDataTermin, setResultDataTermin] = useState<TerminExportExcel[]>([])

    const renderButton = (props: any, ref: any) => {
        return (
            <button
                {...props}
                ref={ref}
                type='button'
                className={`btn btn-light-success mt-3`}
            >
                <i className='fas fa-file-download fs-2 me-2'></i>{' '}
                {intl.formatMessage({ id: 'FORM.LABEL.EXPORT_EXCEL' })}
            </button>
        )
    }

    const getDuration = (data: any) => {
        if (user.data.company_id === companyId.juraganMaterial) {
            data.forEach((eachData: any, index: number) => {
                if (index !== 0) {
                    eachData.duration = getDateRangeDuration(data[index].createdDate, data[index - 1].createdDate);
                } else {
                    eachData.duration = "-"
                }
            })
        } else {
            data.forEach((eachData: any, index: number) => {
                if (index < data.length - 1) {
                    if (user.data.company_id === companyId.esb) {
                        eachData.duration = calculateDayDurations(data[index + 1].createdDate, data[index].createdDate);
                    } else {
                        eachData.duration = getDateRangeDuration(data[index + 1].createdDate, data[index].createdDate);
                    }
                } else {
                    eachData.duration = "-"
                }
            })
        }
    }

    useEffect(() => {
        if (filteredTablesData['pipelines'] && filteredTablesData['pipelines'].length > 0) {
            setResultDataLog(filteredTablesData['pipelines'].map((item) => {
                getDuration(item.lead_logs);

                const leadLogs = item.lead_logs.map((log: any, index: number) => {
                    const getProgressName = checkIsNewProgress(log.leadProgressName) && checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : checkIsNewProgress(log.leadProgressName) ? intl.formatMessage({ id: "FORM.LABEL.NEW" }) : log.leadProgressName
                    return {
                        merchantName: item.merchant_name,
                        picName: item.owner_name,
                        age: getDateSummary(item.lead_age),
                        nominal: item.nominal,
                        source: item.lead_source_name,
                        createdBy: item.creator_name,
                        duration: log.duration,
                        dateStart: log.createdDate,
                        progressName: getProgressName,
                        subProgress: log.leadSubProgressName,
                        description: log?.description || '-',
                        files: log?.attachmentUrls?.length > 0 ? log?.attachmentUrls?.join(', ') : '-',
                    }
                })
                return leadLogs
            }))

            const getTotalNominalTermin = filteredTablesData['pipelines'].reduce((acc: number, item: any) => {
                acc += item.paymentTermins.reduce((acc: number, termin: any) => {
                    acc += termin.nominal
                    return acc
                }, 0)
                return acc
            }, 0)

            const noInvoice = checkIsCompanyHarriette(companyId, user) ? GET_CUSTOM_FIELD_COMPANY_HARRIETE.noInvoice : ''

            const enrichedPipelineData = filteredTablesData['pipelines'].map((item) => {
                if (item.paymentTermins && item.paymentTermins.length === 0 && item.lead_progress_progress_type === 'SUCCESS') {
                    const successLogs = item.lead_logs.filter((log: any) => log.leadProgressType === 'SUCCESS');
                    const lastSuccessLog = successLogs.length > 0 ? successLogs[successLogs.length - 1] : null;

                    const virtualPaymentTermin = {
                        name: 'Lunas',
                        dateDue: null,
                        datePaid: lastSuccessLog ? lastSuccessLog.createdDate : null,
                        nominal: item.nominal,
                        progress: 'PAID'
                    };

                    return {
                        ...item,
                        paymentTermins: [virtualPaymentTermin]
                    };
                }
                return item;
            });

            const getTotalNominalPipelines = enrichedPipelineData.filter((item: any) => item.paymentTermins?.length > 0).reduce((acc: number, item: any) => {
                acc += item.nominal
                return acc
            }, 0)

            const getPaymentTermins = enrichedPipelineData.map((item) => {
                const paymentTermins = item.paymentTermins
                return {
                    merchantName: item.merchant_name,
                    phone: item.merchant_phone,
                    totalNominalPipeline: getTotalNominalPipelines ? currencyFormatter(getTotalNominalPipelines, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) : currencyFormatter(0, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }),
                    nominalPipeline: item.nominal ? currencyFormatter(item.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) : currencyFormatter(0, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }),
                    products: item.leadProducts.map((product: any) => {
                        return `${product.leadProductQty} x ${product.leadProductName} ${product.leadProductNotes ? `- ${product.leadProductNotes}` : ''}`
                    }),
                    totalNominalTermin: getTotalNominalTermin ? currencyFormatter(getTotalNominalTermin, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) : currencyFormatter(0, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }),
                    noInvoice: noInvoice ? item.custom_fields[noInvoice] || '-' : '-',
                    paymentTermins: paymentTermins.map((termin: any) => {
                        return {
                            terminName: termin.name,
                            dateDue: termin.dateDue ? moment(termin.dateDue).format('DD MMM YYYY') : '-',
                            datePaid: termin.datePaid ? moment(termin.datePaid).format('DD MMM YYYY') : '-',
                            nominalTermin: termin.nominal ? currencyFormatter(termin.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) : currencyFormatter(0, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }),
                            statusTermin: termin.progress,
                        }
                    }),
                }
            })

            setResultDataTermin(getPaymentTermins.filter((item) => item.paymentTermins.length > 0))
        }
    }, [filteredTablesData['pipelines']])

    const handelExport = (action: 'pipeline' | 'log' | 'termin') => {
        const startDate = moment(dateRange[0]).format('DD/MM/YYYY')
        const endDate = moment(dateRange[1]).format('DD/MM/YYYY')

        if (action === 'pipeline') {
            return exportExcelPipeline(settings.pipeline_title, 'Pipeline', settings, nameHeader.export, { companyId, keyCustomfield }, selectMultiPipeline, filteredTablesData['pipelines'], columns, user, templatePipelineId);
        } else if (action === 'log') {
            exportExcelLog({
                source: 'Log',
                nameFile: `${selectMultiPipeline.name} - Log`,
                nameHeader: nameHeader.export.log,
                data: resultDataLog,
                selectMultiPipeline
            });
        } else if (action === 'termin') {
            exportExcelTermin({
                source: 'Termin',
                data: resultDataTermin,
                selectMultiPipeline,
                nameFile: `${selectMultiPipeline.name} - Termin (${startDate} - ${endDate})`,
                startDate,
                endDate,
            });
        }
    }

    return (
        <Dropdown renderToggle={(props, ref) => renderButton(props, ref)} noCaret placement="bottomEnd">
            <Dropdown.Item
                disabled={!isFullyLoaded}
                onClick={() => handelExport('pipeline')}
            >
                {settings.pipeline_title}
            </Dropdown.Item>
            <Dropdown.Item
                disabled={!isFullyLoaded}
                onClick={() => handelExport('log')}
            >
                Log
            </Dropdown.Item>
            {
                (user.data.company_id === companyId.harriette || user.data.company_id === companyId.looyalIT) && (
                    <Dropdown.Item
                        disabled={!isFullyLoaded}
                        onClick={() => handelExport('termin')}
                    >
                        {intl.formatMessage({ id: 'FORM.LABEL.SALE' })}
                    </Dropdown.Item>
                )
            }
        </Dropdown >
    )
}

export default BtnActionDropdownExportExcelPipeline